import { call, put } from 'redux-saga/effects';
import * as actions from '../actions/user';
// eslint-disable-next-line import/named
import { post, get } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';
import { formatMessage } from 'devextreme/localization';

export function* userLogout({ payload }) {
  try {
    const corporate = yield call(get, '/public/user/corporate');
    if (!corporate) {
      const logout = yield call(get, '/public/sso-logout-link');
      yield call(get, `${logout}`);
    }

    yield call(post, '/logout/', {});
    yield put(actions.userLogoutSuccess());
  } catch (e) {
    yield put(actions.userLogoutFail());
  }
}

export function* userGetInfo({ payload }) {
  try {
    const response = yield call(get, '/user/info');
    yield put(actions.userGetInfoSuccess(response));
    localStorage.setItem('userInfo', JSON.stringify(response));
  } catch (error) {
    // if (error.response && error.response.status === 401) {}
    yield put(actions.userGetInfoFail((error?.response?.data?.data) ? error?.response?.data : error?.response));
  }
}

export function* userCorporate({ payload }) {
  try {
    const response = yield call(get, '/public/user/corporate');
    yield put(actions.userCorporateSuccess(response));
  } catch (e) {
    yield put(actions.userCorporateFail());
  }
}

export function* userGetPermissions({ payload }) {
  try {
    const response = yield call(get, `/user/permissions?plantId=${payload.plantId}`);
    yield put(actions.userGetPermissionsSuccess(response));
  } catch (error) {
    yield put(actions.userGetPermissionsFail(error.response.data));
  }
}

export function* userConsentNeed({ payload }) {
  try {
    const response = yield call(get, `user/consent/need`);
    yield put(actions.userConsentNeedSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.userConsentNeedFail(error.response.data));
  }
}

export function* userConsentSave({ payload }) {
  try {
    const response = yield call(get, `user/consent/save`);
    yield put(actions.userConsentSaveSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.userConsentSaveFail(error.response.data));
  }
}